import { useEffect, useState } from "react";
import Api from "../openapi";
import { PartnerResponse } from "../openapi/client";

export default function usePartners() {
  const [partners, setPartners] = useState<PartnerResponse[]>();

  useEffect(() => {
    const getPartners = async () => {
      try {
        const res = await Api.Partner.list();
        setPartners(res.data);
      } catch (error) {}
    };
    getPartners();
  }, []);
  return partners;
}
